const styleSheet = () => ({
  container: {
    position: 'relative',
    wordBreak: 'normal !important',
  },
  arrow: {
    position: 'absolute',
    backgroundColor: (props: any) =>
      props.arrowColor ? props.arrowColor : '#213762',
    width: '13px',
    height: '13px',
    transform: 'rotate(45deg)',
  },
  arrow_left: {
    top: '11px',
    right: '-4px',
  },
  arrow_right: {
    top: '11px',
    left: '-4px',
  },
  arrow_top: {
    bottom: '-4px',
    left: '50%',
    transform: 'translateX(-50%) rotate(45deg)',
    marginLeft: '1px',
  },
  arrow_bottom: {
    top: '-4px',
    left: '50%',
    transform: 'translateX(-50%) rotate(45deg)',
    marginLeft: '1px',
  },
  tooltip: {
    width: (props: any) => (props.width ? props.width : 'auto'),
    maxWidth: 'max-content',
    maxHeight: 'max-content',
    position: 'fixed',
    zIndex: 9999999,
    padding: '8px 16px',
    borderRadius: '4px',
    backgroundColor: (props: any) =>
      props.backgroundColor ? props.backgroundColor : '#223762',
    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.2)',
    fontSize: '12px',
    color: '#fff',
    lineHeight: '18px',
    wordBreak: (props: any) => (props.wordBreak ? props.wordBreak : 'normal'),
    display: (props: any) => props.display,
  },
  tooltip_left: {
    left: 0,
  },
  tooltip_right: {
    right: 0,
  },
  tooltip_bottom: {
    bottom: 0,
  },
  tooltip_top: {
    top: 0,
  },
});

export default styleSheet;
